<div *ngIf="!heroExists && !!breadcrumbs && !hideBreadcrumbs" class="jb-breadcrumbs page-margin">
  <div class="jb-breadcrumbs">
    <div class="center jb-max-width">
      <jb-breadcrumbs
        jbSitemapNestedLinker
        [item]="breadcrumbs"
        [theme]="pageHeaderCrumbTheme"
      ></jb-breadcrumbs>
    </div>
  </div>
</div>
